export function emitPageView(pageMetadata) {
  const {_mz, _mze} = global;
  if (!_mz || !_mze) return;
  if (_mz.registerAutoHandlers) _mz.registerAutoHandlers(_mz, _mz.environment);
  global.TES = global.TES || {}; // eslint-disable-line no-param-reassign
  global.TES.pageMetadata = Object.assign({ // eslint-disable-line no-param-reassign
    type: 'answer',
    section: 'answers',
    version: 1,
  }, pageMetadata);
  _mz.emit(_mze.PAGE_VIEW);
}

export function emitError(id, eventTitle) {
  const {_mz, _mze} = global;
  if (!_mz || !_mze) return;
  _mz.emit(_mze.ERROR, {id, eventTitle});
}

export function emitEvent(type, eventData) {
  const {_mz, _mze} = global;
  if (!_mz || !_mze) return;
  _mz.emit(_mze[type], eventData);
}
